import * as React from "react"
import {useTheme} from "@mui/material";
import {ButtonIconSeeker} from "@components/ui"

import {MENU_SIZE} from "../../../../@constants"
import {menuSize} from "../../../../@signals";
import {useApp} from "../../../../@hooks";
import {MaximalLayoutNavToggleButtonStyles} from "./styles";


export default function MaximalLayoutNavToggleButton() {
    const theme = useTheme()
    const { isMini } = useApp()

    return <ButtonIconSeeker
        size="small"
        icon={isMini ? 'angle-right' : 'angle-left'}
        sx={MaximalLayoutNavToggleButtonStyles(theme, isMini)}
        onClick={() => menuSize.value = menuSize.value === MENU_SIZE.EXTENDED ? MENU_SIZE.MINI : MENU_SIZE.EXTENDED}
    />
}